import { parse } from 'qs';
import checkFilter from 'runtypes-filter';

import {
  defaultQueryParams,
  QueryParams,
} from 'src/app/shared/constants/queryParams';
import { isDev } from 'src/app/utils/environment';

import globals from '../globals';

export const getQueryParams = () => {
  const params = globals.window.location.search;

  if (params.length > 0) {
    const paramsLowercase = params.toLowerCase();
    const parsedParams = parse(paramsLowercase, {
      ignoreQueryPrefix: true,
    });

    const validParams = checkFilter(QueryParams)(parsedParams);

    // @NOTE: We are deprecating the use of advertiserId in query params
    // when in production and staging. Instead we are using adv-account-selection package which
    // loads from local storage. We are only keeping this query param available for
    // tests and local development.
    if (!isDev()) {
      delete validParams.advertiserid;
    }

    return validParams;
  }

  return defaultQueryParams;
};

export const setQueryParam = (param: string, value: string | null) => {
  // Update query params
  const queryParams = new URLSearchParams(window.location.search || '');
  if (value === null) {
    queryParams.delete(param);
  } else {
    queryParams.set(param, value);
  }

  // Construct new url
  const allQueryParamValues = Array.from(queryParams.values());
  const queryString =
    allQueryParamValues.length > 0 ? `?${queryParams.toString()}` : '';
  const url = `${window.location.protocol}//${window.location.host}${window.location.pathname}${queryString}`;

  // If does not match existing, redirect
  if (url !== window.location.href) {
    window.location.replace(url);
  }
};
